import { Component, Input } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { SelectedCustomer, SelectedLocation, UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { CUSTOMER_SERVICES } from '../../../../assets/data/CustomerServiceInfo';
import { FeedAdvice } from '../../models/feed-advice.model';

@Component({
  selector: 'app-feed-advice-report',
  templateUrl: './feed-advice-report.component.html',
  styleUrls: ['./feed-advice-report.component.scss'],
  standalone: false,
})
export class FeedAdviceReportComponent {
  @Input() feedAdvice: FeedAdvice;

  customer$: Observable<SelectedCustomer> = this.store.select(UserSelectors.selectCustomer);
  location$: Observable<SelectedLocation> = this.store.select(UserSelectors.selectLocation);

  constructor(private readonly store: Store<RootState>) {}

  getCustomerServiceInfo(country: string): string {
    const customerServiceInfo = CUSTOMER_SERVICES.find((cs) => cs.id === country);
    return `${customerServiceInfo.phone} / ${customerServiceInfo.email}`;
  }

  hasProductComments(): boolean {
    if (this.feedAdvice.productRows !== undefined && this.feedAdvice.productRows.length > 0) {
      return this.feedAdvice.productRows.some(
        (row) => row.comment !== null && row.comment.length > 0,
      );
    }
    return false;
  }

  hasAdditiveComments(): boolean {
    if (this.feedAdvice.additiveRows !== undefined && this.feedAdvice.additiveRows.length > 0) {
      return this.feedAdvice.additiveRows.some(
        (row) => row.comment !== null && row.comment.length > 0,
      );
    }

    return false;
  }

  calculateTons(quantity: number): number | null {
    return this.feedAdvice.numberOfDayOldChicks > 0 && quantity > 0
      ? Math.round((this.feedAdvice.numberOfDayOldChicks * quantity) / 1000000)
      : null;
  }
}
